var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitlabIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 61.477L43.784 25.2H20.216z",
    fill: "#e24329"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 61.477L20.216 25.2H3.7z",
    fill: "#fc6d26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7 25.2L.12 36.23a2.44 2.44 0 0 0 .886 2.728L32 61.477z",
    fill: "#fca326"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7 25.2h16.515L13.118 3.366c-.365-1.124-1.955-1.124-2.32 0z",
    fill: "#e24329"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 61.477L43.784 25.2H60.3z",
    fill: "#fc6d26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3 25.2l3.58 11.02a2.44 2.44 0 0 1-.886 2.728L32 61.477z",
    fill: "#fca326"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3 25.2H43.784l7.098-21.844c.365-1.124 1.955-1.124 2.32 0z",
    fill: "#e24329"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlabIcon);
export default __webpack_public_path__ + "static/media/gitlab-icon.07acbdb53e87ed5e23addb5a9d1ebb22.svg";
export { ForwardRef as ReactComponent };